
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2012-06-07-mac-fonts",
      function () {
        return require("private-next-pages/posts/2012-06-07-mac-fonts.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2012-06-07-mac-fonts"])
      });
    }
  